import { useSelector } from "react-redux";
import { State } from "@App/state";
import { useQuery } from "@apollo/client";
import { GET_KEY_NUMBER, KeyNumberQuery } from "@App/graphql/queries";

export const useKeyNumber = () => {
  const key = useSelector((state: State) => state.orders.key);

  const { loading, data, error } = useQuery<KeyNumberQuery>(GET_KEY_NUMBER, {
    variables: {
      hsn: key.hsn,
      tsn: key.tsn,
    },
  });

  return {
    loading: loading,
    error: error,
    keyNumber: data ? data.keyNumber : null,
  };
};
